import React, { Component } from 'react';
import {
    Box, Typography, Button, CircularProgress, TextField,
    InputAdornment, Dialog, DialogTitle, DialogContent,
    DialogActions, Grid, IconButton, Chip, Card, CardContent,
    CardHeader, Alert, Divider, Pagination
} from '@mui/material';
import {
    Search as SearchIcon,
    DeleteOutline as DeleteIcon,
    AddCircleOutline as AddIcon,
    PowerSettingsNew as LogoutIcon,
    Inventory2Outlined as BoxIcon,
    LocationOnOutlined as LocationIcon,
    LocalShipping as TruckIcon,
    QrCodeScanner as ScanIcon,
    CheckCircle as CheckIcon,
    RefreshOutlined as RefreshIcon,
    ReceiptLong as ReceiptIcon,
    Phone as PhoneIcon,
    FilterAlt as FilterIcon,
    Clear as ClearIcon,
    SearchOff as SearchOffIcon
} from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';

const cookies = new Cookies();

class PackagingIphones extends Component {
    state = {
        orders: [],
        orders2: [],
        companies: [],
        loading: true,
        adminName: '',
        searchValue: '',
        addingOrder: false,
        refreshing: false,
        
        // Pagination
        page: 1,
        totalPages: 1,
        total: 0,
        
        // ✅ Filter & Search
        selectedCompany: '',
        searchOrderId: '',
        searchDeviceId: '',   // ✅ بحث رقم الجهاز
        searchType: 'order',  // 'order' أو 'device'
        searchModal: false,
        
        // Delete Dialog
        deleteDialog: false,
        deleteOrderId: null,
        deleteLoading: false,
        
        // Sana Dialog
        sanaDialog: false,
        sanaValue: '',
        sanaLoading: false,
        selectedPhone: null,
        selectedPhoneName: ''
    };

    componentDidMount() {
        this.fetchProfile();
        this.fetchOrders();
    }

    getHeaders = () => ({
        "Content-Type": "application/x-www-form-urlencoded",
        token: cookies.get("token")
    });

    fetchProfile = () => {
        axios.get(host + `dashbord/profile`, { headers: this.getHeaders() })
            .then(res => {
                this.setState({ adminName: res.data.data.profile.name });
            })
            .catch(() => {
                window.location.href = '/';
            });
    };

    fetchOrders = (page = 1, isRefresh = false) => {
        this.setState({ loading: !isRefresh, refreshing: isRefresh });
        
        const { selectedCompany, searchOrderId, searchDeviceId } = this.state;
        
        // ✅ بناء الـ URL مع الفلاتر
        let url = `dashbord/Packaging/orders/myV2?page=${page}&limit=50`;
        
        // ✅ البحث يتجاوز الفلاتر
        if (searchOrderId) {
            url += `&search=${searchOrderId}`;
        } else if (searchDeviceId) {
            url += `&device=${searchDeviceId}`;
        } else if (selectedCompany) {
            url += `&company=${encodeURIComponent(selectedCompany)}`;
        }
        
        axios.get(host + url, { headers: this.getHeaders() })
            .then(res => {
                const orders = res.data?.order || [];
                const orders2 = res.data?.order2 || [];
                const companies = res.data?.companies || [];
                
                this.setState({
                    orders: Array.isArray(orders) ? orders : [],
                    orders2: Array.isArray(orders2) ? orders2 : [],
                    companies: Array.isArray(companies) ? companies : [],
                    page: res.data?.page || 1,
                    totalPages: res.data?.totalPages || 1,
                    total: res.data?.total || 0,
                    loading: false,
                    refreshing: false
                });
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ orders: [], orders2: [], companies: [], loading: false, refreshing: false });
            });
    };

    handlePageChange = (event, value) => {
        this.setState({ page: value });
        this.fetchOrders(value);
    };

    // ✅ فلتر الشركة
    handleCompanyFilter = (company) => {
        const newCompany = this.state.selectedCompany === company ? '' : company;
        this.setState({ selectedCompany: newCompany, page: 1 }, () => {
            this.fetchOrders(1);
        });
    };

    // ✅ بحث رقم الوصل
    handleSearchOrder = () => {
        this.setState({ page: 1 }, () => {
            this.fetchOrders(1);
        });
    };

    // ✅ مسح الفلاتر
    handleClearFilters = () => {
        this.setState({ 
            selectedCompany: '', 
            searchOrderId: '',
            searchDeviceId: '',
            page: 1 
        }, () => {
            this.fetchOrders(1);
        });
    };

    handleRefresh = () => {
        this.fetchOrders(this.state.page, true);
    };

    handleAddOrder = () => {
        const { searchValue } = this.state;
        if (!searchValue) return;

        this.setState({ addingOrder: true });

        axios.post(host + `dashbord/PackagingV2/order/${searchValue}`, {}, { headers: this.getHeaders() })
            .then(response => {
                if (response.data.check === 1) {
                    toast.warning('⚠️ هذا الطلب يحتوي على أكثر من قطعة!', { autoClose: 5000 });
                } else {
                    toast.success('✅ تم الإضافة بنجاح');
                }
                this.setState({ searchValue: '', addingOrder: false });
                this.fetchOrders();
            })
            .catch(error => {
                this.setState({ addingOrder: false });
                const message = error.response?.data?.message || 'حدث خطأ';
                toast.error(message);
                alert(message);
            });
    };

    handleDeleteOrder = () => {
        const { deleteOrderId } = this.state;
        this.setState({ deleteLoading: true });
        
        axios.post(host + `dashbord/Packaging/delete/${deleteOrderId}`, {}, { headers: this.getHeaders() })
            .then(() => {
                toast.success('تم الحذف بنجاح');
                this.setState({ deleteDialog: false, deleteOrderId: null, deleteLoading: false });
                this.fetchOrders();
            })
            .catch(() => {
                toast.error('حدث خطأ أثناء الحذف');
                this.setState({ deleteLoading: false });
            });
    };

    handleAddSana = () => {
        const { sanaValue, selectedPhone } = this.state;
        if (!sanaValue || !selectedPhone) return;

        this.setState({ sanaLoading: true });

        axios.post(host + `dashbord/packing/sana/add`, {
            phone_id: selectedPhone.id,
            sana_id: sanaValue,
            order_item: selectedPhone.ordersItems.id
        })
        .then(() => {
            toast.success('تم إضافة الجهاز بنجاح');
            this.setState({ 
                sanaDialog: false, 
                sanaValue: '', 
                sanaLoading: false,
                selectedPhone: null 
            });
            this.fetchOrders();
        })
        .catch(error => {
            const message = error.response?.data?.message || 'حدث خطأ';
            alert(message);
            this.setState({ sanaLoading: false });
        });
    };

    handleLogout = () => {
        cookies.remove("token");
        window.location.href = '/';
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleAddOrder();
        }
    };

    handleSanaKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleAddSana();
        }
    };

    openSanaDialog = (phone) => {
        this.setState({
            sanaDialog: true,
            selectedPhone: phone,
            selectedPhoneName: phone?.ordersItems?.components?.name || 'جهاز',
            sanaValue: ''
        });
    };

    render() {
        const { 
            orders2, companies, loading, adminName, searchValue, addingOrder, refreshing,
            page, totalPages, total, selectedCompany, searchOrderId, searchDeviceId, searchType,
            deleteDialog, deleteOrderId, deleteLoading,
            sanaDialog, sanaValue, sanaLoading, selectedPhoneName
        } = this.state;

        // حساب المجموع الكلي
        const totalOrders = total || companies.reduce((sum, c) => sum + (parseInt(c.count) || 0), 0);
        
        // هل يوجد فلتر نشط؟
        const hasActiveFilter = selectedCompany || searchOrderId || searchDeviceId;

        if (!cookies.get("token")) {
            window.location.href = '/';
            return null;
        }

        return (
            <Box dir="rtl" sx={styles.container}>
                {/* Header */}
                <Box sx={styles.header}>
                    <Box sx={styles.headerContent}>
                        <Box sx={styles.logoSection}>
                            <Box sx={styles.logoIcon}>
                                <PhoneIcon sx={{ fontSize: 24 }} />
                            </Box>
                            <Box>
                                <Typography sx={styles.logoText}>تجهيز الأجهزة</Typography>
                                <Typography sx={styles.logoSubtext}>{orders2.length} طلب</Typography>
                            </Box>
                        </Box>
                        
                        <Box sx={styles.userSection}>
                            <Box sx={styles.userInfo}>
                                <Typography sx={styles.userName}>{adminName}</Typography>
                                <Box sx={styles.userStatus}>
                                    <Box sx={styles.statusDot} />
                                    <Typography sx={styles.statusText}>متصل</Typography>
                                </Box>
                            </Box>
                            <IconButton onClick={this.handleLogout} sx={styles.logoutBtn}>
                                <LogoutIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>

                {/* Search Section */}
                <Box sx={styles.searchSection}>
                    <Box sx={styles.searchContainer}>
                        <TextField
                            placeholder="ادخل رقم الوصل للإضافة..."
                            value={searchValue}
                            onChange={(e) => this.setState({ searchValue: e.target.value })}
                            onKeyPress={this.handleKeyPress}
                            fullWidth
                            sx={styles.searchInput}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#9ca3af' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            onClick={this.handleAddOrder}
                                            disabled={addingOrder || !searchValue}
                                            sx={styles.addBtn}
                                        >
                                            {addingOrder ? (
                                                <CircularProgress size={20} sx={{ color: 'white' }} />
                                            ) : (
                                                <>
                                                    <AddIcon sx={{ mr: 0.5 }} />
                                                    إضافة
                                                </>
                                            )}
                                        </Button>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <IconButton 
                            onClick={this.handleRefresh} 
                            sx={styles.refreshBtn}
                            disabled={refreshing}
                        >
                            <RefreshIcon sx={{ 
                                animation: refreshing ? 'spin 1s linear infinite' : 'none',
                                '@keyframes spin': {
                                    '0%': { transform: 'rotate(0deg)' },
                                    '100%': { transform: 'rotate(360deg)' }
                                }
                            }} />
                        </IconButton>
                    </Box>

                    {/* ✅ إحصائيات الشركات + الفلتر + البحث */}
                    {companies.length > 0 && (
                        <Box sx={styles.companiesSection}>
                            <Box sx={styles.companiesHeader}>
                                <TruckIcon sx={{ color: '#6366f1', fontSize: 22 }} />
                                <Typography sx={styles.companiesTitle}>
                                    إحصائيات الشركات
                                </Typography>
                                
                                {/* ✅ زر البحث */}
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<SearchIcon />}
                                    onClick={() => this.setState({ searchModal: true })}
                                    sx={styles.searchBtn}
                                >
                                    بحث
                                </Button>
                                
                                <Chip 
                                    label={`المجموع: ${totalOrders}`}
                                    sx={styles.totalChip}
                                />
                            </Box>

                            {/* ✅ فلتر الشركات */}
                            <Box sx={styles.filterHeader}>
                                <FilterIcon sx={{ color: '#6b7280', fontSize: 18 }} />
                                <Typography sx={styles.filterTitle}>
                                    فلتر حسب الشركة
                                </Typography>
                                {hasActiveFilter && (
                                    <Button
                                        size="small"
                                        startIcon={<ClearIcon />}
                                        onClick={this.handleClearFilters}
                                        sx={styles.clearFilterBtn}
                                    >
                                        مسح الفلاتر
                                    </Button>
                                )}
                            </Box>
                            
                            <Box sx={styles.companiesGrid}>
                                {companies.map((company, index) => {
                                    const isSelected = selectedCompany === company.company;
                                    return (
                                        <Box 
                                            key={index}
                                            onClick={() => this.handleCompanyFilter(company.company)}
                                            sx={{
                                                ...styles.companyCard,
                                                ...(isSelected && styles.companyCardSelected),
                                                animationDelay: `${index * 0.1}s`,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <Box sx={{
                                                ...styles.companyIconBox,
                                                ...(isSelected && styles.companyIconBoxSelected)
                                            }}>
                                                <TruckIcon sx={{ color: 'white', fontSize: 20 }} />
                                            </Box>
                                            <Box sx={styles.companyInfo}>
                                                <Typography sx={{
                                                    ...styles.companyNameText,
                                                    ...(isSelected && { color: '#4f46e5' })
                                                }}>
                                                    {company.company || 'غير محدد'}
                                                </Typography>
                                                <Typography sx={styles.companyCount}>
                                                    {company.count} طلب
                                                </Typography>
                                            </Box>
                                            {isSelected && (
                                                <CheckIcon sx={{ color: '#4f46e5', fontSize: 24 }} />
                                            )}
                                        </Box>
                                    );
                                })}
                            </Box>
                            
                            {/* ✅ عرض الفلتر النشط */}
                            {hasActiveFilter && (
                                <Box sx={styles.activeFilterBox}>
                                    <Typography sx={styles.activeFilterText}>
                                        🔍 نتائج البحث: {total} طلب
                                        {selectedCompany && ` | الشركة: ${selectedCompany}`}
                                        {searchOrderId && ` | رقم الوصل: ${searchOrderId}`}
                                        {searchDeviceId && ` | رقم الجهاز: ${searchDeviceId}`}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>

                {/* Orders Grid */}
                <Box sx={styles.ordersContainer}>
                    {loading ? (
                        <Box sx={styles.loadingState}>
                            <CircularProgress sx={{ color: '#6366f1' }} size={50} />
                            <Typography sx={styles.loadingText}>جاري تحميل الطلبات...</Typography>
                        </Box>
                    ) : orders2.length === 0 ? (
                        <Box sx={styles.emptyState}>
                            <Box sx={styles.emptyIcon}>
                                <BoxIcon sx={{ fontSize: 60, color: '#9ca3af' }} />
                            </Box>
                            <Typography sx={styles.emptyTitle}>لا توجد طلبات</Typography>
                            <Typography sx={styles.emptySubtitle}>
                                أضف طلبات جديدة باستخدام رقم الوصل
                            </Typography>
                        </Box>
                    ) : (
                        <>
                        <Grid container spacing={2}>
                            {orders2.map((order, index) => {
                                // ✅ التحقق من وجود البيانات
                                if (!order?.order) return null;
                                
                                const orderData = order.order;
                                const isMultiple = (orderData.items_count || 0) > 1;
                                const printerOrder = orderData.printerOrders?.[0];
                                const prints = printerOrder?.prints;
                                const iphones = order.iphone || [];

                                return (
                                    <Grid item xs={12} sm={6} md={4} key={order.id || index}>
                                        <Card sx={{
                                            ...styles.orderCard,
                                            ...(isMultiple && styles.multipleCard)
                                        }}>
                                            {/* Card Header */}
                                            <CardHeader
                                                sx={{
                                                    ...styles.cardHeader,
                                                    background: isMultiple 
                                                        ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
                                                        : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
                                                }}
                                                title={
                                                    <Box sx={{ textAlign: 'center' }}>
                                                        <Typography sx={styles.cardHeaderLabel}>
                                                            رقم الوصل
                                                        </Typography>
                                                        <Typography sx={styles.cardHeaderValue}>
                                                            {orderData.id}
                                                        </Typography>
                                                    </Box>
                                                }
                                            />

                                            <CardContent sx={styles.cardBody}>
                                                {/* شركة التوصيل - كبير وواضح */}
                                                {prints && (
                                                    <Box sx={styles.companyBox}>
                                                        <TruckIcon sx={{ color: '#6366f1', fontSize: 28 }} />
                                                        <Typography sx={styles.companyName}>
                                                            {prints.name || 'غير محدد'}
                                                        </Typography>
                                                    </Box>
                                                )}

                                                {/* العنوان - كبير وواضح */}
                                                <Box sx={styles.addressBox}>
                                                    <LocationIcon sx={{ color: '#10b981', fontSize: 26 }} />
                                                    <Typography sx={styles.addressText}>
                                                        {orderData.government || 'غير محدد'} / {orderData.city || ''}
                                                    </Typography>
                                                </Box>

                                                <Divider sx={{ my: 2 }} />

                                                {/* السعر وعدد القطع */}
                                                <Box sx={styles.statsRow}>
                                                    <Box sx={styles.statBox}>
                                                        <Typography sx={styles.statLabel}>السعر</Typography>
                                                        <Typography sx={styles.statValue}>
                                                            {orderData.price?.toLocaleString() || 0}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{
                                                        ...styles.statBox,
                                                        ...(isMultiple && styles.statBoxWarning)
                                                    }}>
                                                        <Typography sx={styles.statLabel}>القطع</Typography>
                                                        <Typography sx={{
                                                            ...styles.statValue,
                                                            color: isMultiple ? '#dc2626' : '#1f2937'
                                                        }}>
                                                            {orderData.items_count || 0}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                {/* المنتج */}
                                                {orderData.notes2 && (
                                                    <Box sx={styles.productBox}>
                                                        <Typography sx={styles.productText}>
                                                            {orderData.notes2}
                                                        </Typography>
                                                    </Box>
                                                )}

                                                {/* الأجهزة (iphones) - تصميم جديد مع Animation */}
                                                {iphones.length > 0 && (
                                                    <Box sx={styles.iphonesSection}>
                                                        <Typography sx={styles.sectionTitle}>
                                                            <PhoneIcon sx={{ fontSize: 20, mr: 0.5 }} />
                                                            الأجهزة ({iphones.length})
                                                        </Typography>
                                                        <Box sx={styles.iphonesGrid}>
                                                            {iphones.map((phone, i) => {
                                                                if (!phone) return null;
                                                                
                                                                const hasSana = !!phone.sana;
                                                                const componentName = phone.ordersItems?.components?.name || 'جهاز';
                                                                
                                                                return (
                                                                    <Box 
                                                                        key={phone.id || i}
                                                                        sx={{
                                                                            animation: 'fadeInUp 0.4s ease',
                                                                            animationDelay: `${i * 0.1}s`,
                                                                            animationFillMode: 'both',
                                                                            '@keyframes fadeInUp': {
                                                                                '0%': { opacity: 0, transform: 'translateY(20px)' },
                                                                                '100%': { opacity: 1, transform: 'translateY(0)' }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {hasSana ? (
                                                                            // ✅ الجهاز تمت إضافته
                                                                            <Box sx={styles.deviceCardAdded}>
                                                                                <Box sx={styles.deviceIconAdded}>
                                                                                    <CheckIcon sx={{ fontSize: 24, color: 'white' }} />
                                                                                </Box>
                                                                                <Box sx={styles.deviceInfo}>
                                                                                    <Typography sx={styles.deviceName}>
                                                                                        {phone.sana?.item_out?.name || componentName}
                                                                                    </Typography>
                                                                                    <Chip 
                                                                                        label={`# ${phone.sana?.id}`}
                                                                                        size="small"
                                                                                        sx={styles.deviceChip}
                                                                                    />
                                                                                </Box>
                                                                            </Box>
                                                                        ) : (
                                                                            // ❌ الجهاز لم يُضاف بعد - قابل للنقر
                                                                            <Box 
                                                                                sx={styles.deviceCardPending}
                                                                                onClick={() => this.openSanaDialog(phone)}
                                                                            >
                                                                                <Box sx={styles.deviceIconPending}>
                                                                                    <ScanIcon sx={{ 
                                                                                        fontSize: 24, 
                                                                                        color: '#6366f1',
                                                                                        animation: 'pulse 2s infinite',
                                                                                        '@keyframes pulse': {
                                                                                            '0%, 100%': { transform: 'scale(1)' },
                                                                                            '50%': { transform: 'scale(1.1)' }
                                                                                        }
                                                                                    }} />
                                                                                </Box>
                                                                                <Box sx={styles.deviceInfo}>
                                                                                    <Typography sx={styles.deviceNamePending}>
                                                                                        {componentName}
                                                                                    </Typography>
                                                                                    <Typography sx={styles.deviceHint}>
                                                                                        اضغط لمسح الباركود
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={styles.scanArrow}>
                                                                                    👆
                                                                                </Box>
                                                                            </Box>
                                                                        )}
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>
                                                    </Box>
                                                )}
                                            </CardContent>

                                            {/* زر الإلغاء */}
                                            <Box sx={styles.cardFooter}>
                                                <Button
                                                    fullWidth
                                                    onClick={() => this.setState({ 
                                                        deleteDialog: true, 
                                                        deleteOrderId: order.id 
                                                    })}
                                                    sx={styles.deleteBtn}
                                                    startIcon={<DeleteIcon />}
                                                >
                                                    إلغاء
                                                </Button>
                                            </Box>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>

                        {/* ✅ Pagination */}
                        {totalPages > 1 && (
                            <Box sx={styles.paginationContainer}>
                                <Pagination
                                    count={totalPages}
                                    page={page}
                                    onChange={this.handlePageChange}
                                    color="primary"
                                    size="large"
                                    showFirstButton
                                    showLastButton
                                    sx={styles.pagination}
                                />
                                <Typography sx={styles.paginationText}>
                                    صفحة {page} من {totalPages} | إجمالي: {total}
                                </Typography>
                            </Box>
                        )}
                        </>
                    )}
                </Box>

                {/* Delete Dialog */}
                <Dialog 
                    open={deleteDialog} 
                    onClose={() => !deleteLoading && this.setState({ deleteDialog: false })}
                    PaperProps={{ sx: styles.dialog }}
                >
                    <DialogTitle sx={styles.dialogTitle}>
                        <DeleteIcon sx={{ fontSize: 40, color: '#ef4444', mb: 1 }} />
                        <Typography variant="h6">تأكيد الإلغاء</Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Alert severity="warning" sx={{ borderRadius: 2 }}>
                            هل تريد إلغاء الطلب رقم <strong>{deleteOrderId}</strong>؟
                        </Alert>
                    </DialogContent>
                    <DialogActions sx={styles.dialogActions}>
                        <Button 
                            onClick={() => this.setState({ deleteDialog: false })}
                            disabled={deleteLoading}
                            sx={styles.cancelBtn}
                        >
                            رجوع
                        </Button>
                        <Button 
                            onClick={this.handleDeleteOrder}
                            disabled={deleteLoading}
                            sx={styles.confirmDeleteBtn}
                        >
                            {deleteLoading ? <CircularProgress size={20} /> : 'نعم، إلغاء'}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Sana Dialog */}
                <Dialog 
                    open={sanaDialog} 
                    onClose={() => !sanaLoading && this.setState({ sanaDialog: false })}
                    PaperProps={{ sx: styles.dialog }}
                >
                    <DialogTitle sx={styles.dialogTitle}>
                        <ScanIcon sx={{ fontSize: 40, color: '#6366f1', mb: 1 }} />
                        <Typography variant="h6">{selectedPhoneName}</Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Alert severity="info" sx={{ borderRadius: 2, mb: 2 }}>
                            امسح باركود الجهاز الخاص بـ {selectedPhoneName}
                        </Alert>
                        <TextField
                            fullWidth
                            autoFocus
                            type="number"
                            placeholder="أدخل رقم الجهاز"
                            value={sanaValue}
                            onChange={(e) => this.setState({ sanaValue: e.target.value })}
                            onKeyPress={this.handleSanaKeyPress}
                            sx={styles.sanaInput}
                        />
                    </DialogContent>
                    <DialogActions sx={styles.dialogActions}>
                        <Button 
                            onClick={() => this.setState({ sanaDialog: false })}
                            disabled={sanaLoading}
                            sx={styles.cancelBtn}
                        >
                            إلغاء
                        </Button>
                        <Button 
                            onClick={this.handleAddSana}
                            disabled={sanaLoading || !sanaValue}
                            sx={styles.confirmBtn}
                        >
                            {sanaLoading ? <CircularProgress size={20} /> : 'إضافة'}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* ✅ Search Modal */}
                <Dialog 
                    open={this.state.searchModal} 
                    onClose={() => this.setState({ searchModal: false })}
                    PaperProps={{ sx: styles.searchDialog }}
                >
                    <DialogTitle sx={styles.searchDialogTitle}>
                        <SearchIcon sx={{ fontSize: 40, color: '#6366f1', mb: 1 }} />
                        <Typography variant="h6">بحث</Typography>
                    </DialogTitle>
                    <DialogContent>
                        {/* ✅ Tabs للتبديل بين نوع البحث */}
                        <Box sx={styles.searchTabs}>
                            <Button
                                fullWidth
                                variant={searchType === 'order' ? 'contained' : 'outlined'}
                                onClick={() => this.setState({ searchType: 'order', searchDeviceId: '' })}
                                sx={searchType === 'order' ? styles.searchTabActive : styles.searchTab}
                                startIcon={<ReceiptIcon />}
                            >
                                رقم الوصل
                            </Button>
                            <Button
                                fullWidth
                                variant={searchType === 'device' ? 'contained' : 'outlined'}
                                onClick={() => this.setState({ searchType: 'device', searchOrderId: '' })}
                                sx={searchType === 'device' ? styles.searchTabActive : styles.searchTab}
                                startIcon={<PhoneIcon />}
                            >
                                رقم الجهاز
                            </Button>
                        </Box>

                        {/* ✅ حقل البحث */}
                        <TextField
                            fullWidth
                            autoFocus
                            type="number"
                            placeholder={searchType === 'order' ? 'أدخل رقم الوصل...' : 'أدخل رقم الجهاز (Sana)...'}
                            value={searchType === 'order' ? searchOrderId : searchDeviceId}
                            onChange={(e) => {
                                if (searchType === 'order') {
                                    this.setState({ searchOrderId: e.target.value, searchDeviceId: '' });
                                } else {
                                    this.setState({ searchDeviceId: e.target.value, searchOrderId: '' });
                                }
                            }}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    const hasValue = searchType === 'order' ? searchOrderId : searchDeviceId;
                                    if (hasValue) {
                                        // ✅ إلغاء تحديد الشركة عند البحث
                                        this.setState({ 
                                            searchModal: false, 
                                            page: 1,
                                            selectedCompany: ''
                                        }, () => {
                                            this.fetchOrders(1);
                                        });
                                    }
                                }
                            }}
                            sx={styles.searchModalInput}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {searchType === 'order' 
                                            ? <ReceiptIcon sx={{ color: '#6366f1' }} />
                                            : <PhoneIcon sx={{ color: '#6366f1' }} />
                                        }
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {/* ✅ ملاحظة */}
                        <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
                            {searchType === 'order' 
                                ? '🔍 البحث برقم الوصل يتجاوز فلتر الشركة'
                                : '📱 البحث برقم الجهاز يعرض الطلب المرتبط به'
                            }
                        </Alert>
                    </DialogContent>
                    <DialogActions sx={styles.dialogActions}>
                        <Button 
                            onClick={() => this.setState({ searchModal: false })}
                            sx={styles.cancelBtn}
                        >
                            إلغاء
                        </Button>
                        <Button 
                            onClick={() => {
                                // ✅ إلغاء تحديد الشركة عند البحث
                                this.setState({ 
                                    searchModal: false, 
                                    page: 1,
                                    selectedCompany: ''
                                }, () => {
                                    this.fetchOrders(1);
                                });
                            }}
                            disabled={!(searchOrderId || searchDeviceId)}
                            sx={styles.confirmBtn}
                        >
                            بحث
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    rtl={true}
                    theme="colored"
                />
            </Box>
        );
    }
}

// ✅ Styles
const styles = {
    container: {
        minHeight: '100vh',
        background: '#f8fafc'
    },
    
    // Header
    header: {
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
    },
    headerContent: {
        maxWidth: 1400,
        mx: 'auto',
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    logoSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
    },
    logoIcon: {
        width: 44,
        height: 44,
        borderRadius: 2,
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white'
    },
    logoText: {
        fontSize: 18,
        fontWeight: 700,
        color: '#1f2937'
    },
    logoSubtext: {
        fontSize: 12,
        color: '#6b7280'
    },
    userSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
    },
    userInfo: {
        textAlign: 'left'
    },
    userName: {
        fontSize: 14,
        fontWeight: 600,
        color: '#1f2937'
    },
    userStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: '#22c55e'
    },
    statusText: {
        fontSize: 11,
        color: '#22c55e'
    },
    logoutBtn: {
        color: '#6b7280',
        '&:hover': { color: '#ef4444', background: '#fef2f2' }
    },

    // Search
    searchSection: {
        maxWidth: 1400,
        mx: 'auto',
        px: 2,
        py: 3
    },
    searchContainer: {
        display: 'flex',
        gap: 1,
        alignItems: 'center'
    },
    searchInput: {
        flex: 1,
        '& .MuiOutlinedInput-root': {
            background: 'white',
            borderRadius: 3,
            pr: 1,
            '& fieldset': { borderColor: '#e5e7eb' },
            '&:hover fieldset': { borderColor: '#6366f1' },
            '&.Mui-focused fieldset': { borderColor: '#6366f1', borderWidth: 2 }
        }
    },
    addBtn: {
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: 'white',
        borderRadius: 2,
        px: 2,
        py: 1,
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': { background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' },
        '&:disabled': { background: '#e5e7eb', color: '#9ca3af' }
    },
    refreshBtn: {
        background: 'white',
        border: '1px solid #e5e7eb',
        '&:hover': { background: '#f9fafb' }
    },

    // ✅ إحصائيات الشركات
    companiesSection: {
        mt: 3,
        p: 2.5,
        background: 'white',
        borderRadius: 3,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
    },
    companiesHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 2
    },
    companiesTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: '#1f2937',
        flex: 1
    },
    totalChip: {
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: 'white',
        fontWeight: 700,
        fontSize: 14,
        px: 1
    },
    companiesGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2
    },
    companyCard: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 2,
        minWidth: 160,
        flex: '1 1 auto',
        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
        borderRadius: 2,
        border: '1px solid #e2e8f0',
        transition: 'all 0.3s ease',
        animation: 'fadeIn 0.5s ease',
        '@keyframes fadeIn': {
            '0%': { opacity: 0, transform: 'translateY(10px)' },
            '100%': { opacity: 1, transform: 'translateY(0)' }
        },
        '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 8px 25px rgba(99, 102, 241, 0.15)',
            borderColor: '#6366f1'
        }
    },
    companyIconBox: {
        width: 40,
        height: 40,
        borderRadius: 2,
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    companyInfo: {
        flex: 1
    },
    companyNameText: {
        fontSize: 15,
        fontWeight: 700,
        color: '#1f2937',
        mb: 0.3
    },
    companyCount: {
        fontSize: 13,
        color: '#6366f1',
        fontWeight: 600
    },
    
    // ✅ زر البحث
    searchBtn: {
        borderRadius: 2,
        borderColor: '#6366f1',
        color: '#6366f1',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': {
            borderColor: '#4f46e5',
            background: '#eef2ff'
        }
    },
    
    // ✅ Search Modal
    searchDialog: {
        borderRadius: 4,
        minWidth: 380
    },
    searchDialogTitle: {
        textAlign: 'center',
        pt: 3
    },
    searchModalInput: {
        mt: 2,
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            fontSize: 18,
            '& fieldset': { borderColor: '#e5e7eb' },
            '&:hover fieldset': { borderColor: '#6366f1' },
            '&.Mui-focused fieldset': { borderColor: '#6366f1', borderWidth: 2 }
        },
        '& input': {
            textAlign: 'center',
            fontWeight: 600
        }
    },
    
    // ✅ Search Tabs
    searchTabs: {
        display: 'flex',
        gap: 1,
        mb: 2
    },
    searchTab: {
        borderRadius: 2,
        borderColor: '#e5e7eb',
        color: '#6b7280',
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            borderColor: '#6366f1',
            background: '#f8fafc'
        }
    },
    searchTabActive: {
        borderRadius: 2,
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: 'white',
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)'
        }
    },
    
    // ✅ فلتر الشركات
    filterHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 1.5
    },
    filterTitle: {
        fontSize: 13,
        color: '#6b7280',
        fontWeight: 500,
        flex: 1
    },
    clearFilterBtn: {
        fontSize: 14,
        fontWeight: 700,
        color: '#ef4444',
        textTransform: 'none',
        px: 2,
        py: 1,
        borderRadius: 2,
        background: '#fef2f2',
        border: '2px solid #fca5a5',
        animation: 'pulse-filter 1.5s infinite',
        '@keyframes pulse-filter': {
            '0%, 100%': { 
                transform: 'scale(1)',
                boxShadow: '0 0 0 0 rgba(239, 68, 68, 0.4)'
            },
            '50%': { 
                transform: 'scale(1.05)',
                boxShadow: '0 0 0 8px rgba(239, 68, 68, 0)'
            }
        },
        '&:hover': { 
            background: '#fee2e2',
            transform: 'scale(1.1)'
        }
    },
    
    // ✅ كارد الشركة المحددة
    companyCardSelected: {
        background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
        borderColor: '#6366f1',
        boxShadow: '0 4px 15px rgba(99, 102, 241, 0.2)'
    },
    companyIconBoxSelected: {
        background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)'
    },
    
    // ✅ الفلتر النشط
    activeFilterBox: {
        mt: 2,
        p: 1.5,
        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
        borderRadius: 2,
        border: '1px solid #f59e0b'
    },
    activeFilterText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#92400e',
        textAlign: 'center'
    },

    // ✅ Pagination
    paginationContainer: {
        mt: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        p: 3,
        background: 'white',
        borderRadius: 3,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
    },
    pagination: {
        '& .MuiPaginationItem-root': {
            fontWeight: 600,
            fontSize: 16,
            '&.Mui-selected': {
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white'
            }
        }
    },
    paginationText: {
        fontSize: 14,
        color: '#6b7280',
        fontWeight: 500
    },

    // Orders
    ordersContainer: {
        maxWidth: 1400,
        mx: 'auto',
        px: 2,
        pb: 4
    },
    
    // States
    loadingState: {
        textAlign: 'center',
        py: 10
    },
    loadingText: {
        mt: 2,
        color: '#6b7280',
        fontSize: 14
    },
    emptyState: {
        textAlign: 'center',
        py: 10,
        background: 'white',
        borderRadius: 4,
        border: '2px dashed #e5e7eb'
    },
    emptyIcon: {
        width: 100,
        height: 100,
        borderRadius: '50%',
        background: '#f3f4f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mx: 'auto',
        mb: 2
    },
    emptyTitle: {
        fontSize: 18,
        fontWeight: 600,
        color: '#374151',
        mb: 0.5
    },
    emptySubtitle: {
        fontSize: 14,
        color: '#9ca3af'
    },

    // Order Card
    orderCard: {
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: '1px solid #e5e7eb',
        transition: 'all 0.2s ease',
        '&:hover': {
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            transform: 'translateY(-2px)'
        }
    },
    multipleCard: {
        border: '2px solid #fca5a5',
        boxShadow: '0 0 0 4px #fef2f2'
    },
    cardHeader: {
        p: 2,
        color: 'white',
        '& .MuiCardHeader-content': {
            overflow: 'visible'
        }
    },
    cardHeaderLabel: {
        fontSize: 11,
        opacity: 0.9
    },
    cardHeaderValue: {
        fontSize: 28,
        fontWeight: 700
    },
    cardBody: {
        p: 2
    },
    infoRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 1
    },
    infoText: {
        fontSize: 14,
        color: '#374151',
        flex: 1
    },
    chip: {
        background: '#f3f4f6',
        fontWeight: 600
    },
    
    // شركة التوصيل - كبير وواضح
    companyBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 2,
        p: 1.5,
        background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
        borderRadius: 2,
        border: '1px solid #c7d2fe'
    },
    companyName: {
        fontSize: 20,
        fontWeight: 700,
        color: '#4338ca',
        flex: 1
    },
    
    // العنوان - كبير وواضح
    addressBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
        borderRadius: 2,
        border: '1px solid #a7f3d0'
    },
    addressText: {
        fontSize: 18,
        fontWeight: 600,
        color: '#065f46',
        flex: 1
    },
    statsRow: {
        display: 'flex',
        gap: 1.5,
        mb: 2
    },
    statBox: {
        flex: 1,
        background: '#f9fafb',
        borderRadius: 2,
        p: 1.5,
        textAlign: 'center'
    },
    statBoxWarning: {
        background: '#fef2f2'
    },
    statLabel: {
        fontSize: 11,
        color: '#6b7280',
        mb: 0.3
    },
    statValue: {
        fontSize: 20,
        fontWeight: 700,
        color: '#1f2937'
    },
    productBox: {
        background: '#fef9c3',
        borderRadius: 2,
        p: 1.5,
        mb: 2
    },
    productText: {
        fontSize: 14,
        fontWeight: 600,
        color: '#854d0e',
        textAlign: 'center'
    },
    
    // Iphones Section - تصميم جديد
    iphonesSection: {
        mt: 2,
        p: 2,
        background: '#fafafa',
        borderRadius: 3,
        border: '2px dashed #e5e7eb'
    },
    sectionTitle: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 15,
        fontWeight: 700,
        color: '#374151',
        mb: 2
    },
    iphonesGrid: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5
    },
    
    // كارد الجهاز المُضاف
    deviceCardAdded: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
        borderRadius: 2,
        border: '2px solid #86efac',
        boxShadow: '0 2px 8px rgba(34, 197, 94, 0.2)'
    },
    deviceIconAdded: {
        width: 44,
        height: 44,
        borderRadius: 2,
        background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    deviceInfo: {
        flex: 1
    },
    deviceName: {
        fontSize: 15,
        fontWeight: 600,
        color: '#166534',
        mb: 0.5
    },
    deviceChip: {
        background: '#fef3c7',
        color: '#92400e',
        fontWeight: 700,
        fontSize: 16,
        py: 0.5,
        px: 1
    },
    
    // كارد الجهاز الغير مُضاف - تفاعلي
    deviceCardPending: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        background: 'linear-gradient(135deg, #fff 0%, #f8fafc 100%)',
        borderRadius: 2,
        border: '2px solid #c7d2fe',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(99, 102, 241, 0.1)',
        '&:hover': {
            transform: 'scale(1.02)',
            boxShadow: '0 8px 25px rgba(99, 102, 241, 0.25)',
            borderColor: '#6366f1',
            background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },
    deviceIconPending: {
        width: 44,
        height: 44,
        borderRadius: 2,
        background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
        border: '2px dashed #6366f1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    deviceNamePending: {
        fontSize: 15,
        fontWeight: 700,
        color: '#1f2937',
        mb: 0.3
    },
    deviceHint: {
        fontSize: 12,
        color: '#6366f1',
        fontWeight: 500
    },
    scanArrow: {
        fontSize: 24,
        animation: 'bounce 1s infinite',
        '@keyframes bounce': {
            '0%, 100%': { transform: 'translateY(0)' },
            '50%': { transform: 'translateY(-5px)' }
        }
    },
    
    addSanaBtn: {
        background: '#f3f4f6',
        color: '#374151',
        borderRadius: 2,
        py: 1,
        fontWeight: 500,
        textTransform: 'none',
        justifyContent: 'flex-start',
        '&:hover': { background: '#e5e7eb' }
    },
    sanaAddedBtn: {
        background: '#dcfce7',
        color: '#166534',
        borderRadius: 2,
        py: 1,
        fontWeight: 500,
        textTransform: 'none',
        justifyContent: 'flex-start',
        '&:hover': { background: '#bbf7d0' }
    },
    sanaChip: {
        background: '#fef3c7',
        color: '#92400e',
        fontWeight: 700,
        mt: 0.5
    },
    
    cardFooter: {
        p: 2,
        pt: 0
    },
    deleteBtn: {
        background: '#fef2f2',
        color: '#dc2626',
        borderRadius: 2,
        py: 1,
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': { background: '#fee2e2' }
    },

    // Dialog
    dialog: {
        borderRadius: 4,
        minWidth: 340
    },
    dialogTitle: {
        textAlign: 'center',
        pt: 3
    },
    dialogActions: {
        justifyContent: 'center',
        gap: 1,
        pb: 3
    },
    cancelBtn: {
        px: 3,
        py: 1,
        borderRadius: 2,
        color: '#6b7280',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': { background: '#f3f4f6' }
    },
    confirmDeleteBtn: {
        px: 3,
        py: 1,
        borderRadius: 2,
        background: '#ef4444',
        color: 'white',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': { background: '#dc2626' }
    },
    confirmBtn: {
        px: 3,
        py: 1,
        borderRadius: 2,
        background: '#6366f1',
        color: 'white',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': { background: '#4f46e5' }
    },
    sanaInput: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 2
        }
    }
};

export default PackagingIphones;
